/**
 * Presentación del panel por plan — solo navegación / UI.
 * No bloquea rutas ni operaciones; el backend sigue aplicando candados reales.
 */
import { normalizeSaasPlanId } from '@/soluqr/core/capabilities';

/** Ítems del sidebar visibles en plan Venta (matriz comercial). */
export const VENTA_NAV_PATHS = new Set([
  '/dashboard',
  '/dashboard/orders',
  '/dashboard/reports',
  '/dashboard/config',
  '/dashboard/design',
  '/dashboard/products',
  '/dashboard/assistant-training',
  '/dashboard/analytics',
  '/dashboard/qr',
  '/dashboard/membership',
  '/dashboard/support',
]);

export function isVentaPlan(planId) {
  return normalizeSaasPlanId(planId) === 'venta';
}

/**
 * @param {string} path
 * @param {string|null|undefined} planId
 */
export function isNavPathVisibleForPlan(path, planId) {
  if (!isVentaPlan(planId)) return true;
  const norm = String(path || '').replace(/\/$/, '') || '/dashboard';
  return VENTA_NAV_PATHS.has(norm);
}

/**
 * Recorta sidebar solo en plan Venta (resto de planes sin cambios).
 * @param {{ path?: string }[]} items
 * @param {string|null|undefined} planId
 */
export function filterNavItemsForPlanVisual(items, planId) {
  if (!isVentaPlan(planId)) return items || [];
  return (items || []).filter((item) => {
    if (!item?.path) return true;
    return isNavPathVisibleForPlan(item.path, planId);
  });
}
